export default (mobile, tablet = mobile, desktop = tablet) =>
  `(max-width: 768px) ${mobile}, (max-width: 1023px) ${tablet}, (min-width: 1024px) ${desktop}`;
